"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 接口配置模块
var _default = exports.default = {
  getConfigList: function getConfigList(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/configItem/list',
      method: 'post',
      data: data
    });
  },
  getConfigById: function getConfigById(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/configItem/query/' + id,
      method: 'post'
    });
  },
  savaConfig: function savaConfig(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/configItem/save',
      method: 'post',
      data: data
    });
  },
  updateStatus: function updateStatus(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/configItem/updateStatus',
      method: 'post',
      data: data
    });
  },
  getConfigByCode: function getConfigByCode(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/configItem/queryByCode',
      method: 'post',
      data: data
    });
  },
  getLanguageInfoQueryAll: function getLanguageInfoQueryAll(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/languageInfo/query/all',
      method: 'post',
      data: data
    });
  }
};